import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/dashboards/gz-console';

export class CompanySelectorBaseDataProvider extends BaseWebComponentDataProvider {
  async getCompanies(request: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    throw new Error('Needs to be implemented');
  }
}
